(function(){
  var root = document.getElementById('zorro-page');
  if(!root || root.dataset.init) return;
  root.dataset.init = '1';
  function money(c){ return '€' + (c/100).toFixed(2).replace('.', ','); }
  function escapeHtml(value){
    return String(value || '').replace(/[&<>"']/g, function(character){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character];
    });
  }
  var shippingMessage = root.dataset.shippingMessage || '€6,20 straight-to-door in Finland for 1–2 pairs. Larger shinpad orders use a higher non-door rate.';
  var emptyCartLabel = root.dataset.emptyCartLabel || 'Your cart is empty';
  var addedLabel = root.dataset.addedLabel || 'Added';

  var drawer = document.getElementById('zdrawer');
  var scrim = document.getElementById('zscrim');
  function openCart(){ if(!drawer || !scrim) return; drawer.classList.add('open'); scrim.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('zorro-cart-open'); }
  function closeCart(){ if(!drawer || !scrim) return; drawer.classList.remove('open'); scrim.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('zorro-cart-open'); }
  document.getElementById('zcart-open').addEventListener('click', function(){ refresh(true); });
  document.getElementById('zcart-close').addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); closeCart(); });
  scrim.addEventListener('click', function(e){ e.preventDefault(); closeCart(); });
  document.addEventListener('click', function(e){ if(!drawer || !drawer.classList.contains('open')) return; if(drawer.contains(e.target) || e.target.closest('#zcart-open')) return; closeCart(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });

  function render(cart){
    var body = document.getElementById('zcart-body');
    var count = cart.item_count;
    document.getElementById('zcart-count').textContent = count;
    var badge = document.getElementById('zcart-badge');
    badge.textContent = count;
    badge.classList.toggle('on', count > 0);
    document.getElementById('zcart-subtotal').textContent = money(cart.total_price);

    document.getElementById('zship-msg').innerHTML = '<span style="color:var(--accent);">✓ ' + escapeHtml(shippingMessage) + '</span>';

    if(!cart.items.length){
      body.innerHTML = '<div style="text-align:center;padding:60px 20px;color:rgba(255,255,255,0.5);">'
        + '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h2.5l2.2 12.3a1 1 0 0 0 1 .8h9.6a1 1 0 0 0 1-.8L21 7H6"/></svg>'
        + '<div style="margin-top:14px;font-family:var(--font-mono);font-size:12px;letter-spacing:0.06em;text-transform:uppercase;">'+escapeHtml(emptyCartLabel)+'</div></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      html += '<div class="cart-row" data-key="'+it.key+'">'
        + (img ? '<img src="'+img+'" alt="">' : '<div style="width:68px;height:68px;border-radius:10px;background:#0e0e11;flex-shrink:0;"></div>')
        + '<div style="flex:1;min-width:0;">'
        + '<div style="font-family:var(--font-display);font-weight:700;font-style:italic;font-size:14px;text-transform:uppercase;color:#fff;line-height:1.1;">'+it.product_title+'</div>'
        + (it.variant_title ? '<div style="font-family:var(--font-mono);font-size:10px;color:rgba(255,255,255,0.5);text-transform:uppercase;margin-top:3px;">'+it.variant_title+'</div>' : '')
        + '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;">'
        + '<div class="qty"><button data-act="dec" aria-label="Decrease"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg></button>'
        + '<span>'+it.quantity+'</span>'
        + '<button data-act="inc" aria-label="Increase"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div>'
        + '<span style="font-family:var(--font-display);font-weight:700;font-size:15px;color:#fff;">'+money(it.final_line_price)+'</span>'
        + '</div></div>'
        + '<button class="cart-x" data-act="remove" aria-label="Remove"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
        + '</div>';
    });
    body.innerHTML = html;
  }

  function refresh(open){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); if(open) openCart(); });
  }

  function changeQty(key, qty){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id:key, quantity:qty})})
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); });
  }

  document.getElementById('zcart-body').addEventListener('click', function(e){
    var btn = e.target.closest('button[data-act]');
    if(!btn) return;
    var row = btn.closest('.cart-row');
    var key = row.getAttribute('data-key');
    var qtySpan = row.querySelector('.qty span');
    var cur = parseInt(qtySpan.textContent, 10) || 0;
    var act = btn.getAttribute('data-act');
    if(act==='inc') changeQty(key, cur+1);
    else if(act==='dec') changeQty(key, Math.max(0, cur-1));
    else if(act==='remove') changeQty(key, 0);
  });

  root.querySelectorAll('.zadd').forEach(function(b){
    b.addEventListener('click', function(){
      var id = b.getAttribute('data-variant-id');
      if(!id) return;
      var label = b.innerHTML;
      b.disabled = true;
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id:id, quantity:1})})
        .then(function(r){ return r.json(); })
        .then(function(){
          b.classList.remove('zbtn-outline'); b.classList.add('zbtn-accent');
          b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m4 12 5 5L20 6"/></svg> '+escapeHtml(addedLabel);
          refresh(true);
          setTimeout(function(){ b.classList.add('zbtn-outline'); b.classList.remove('zbtn-accent'); b.innerHTML = label; b.disabled = false; }, 1400);
        })
        .catch(function(){ b.disabled = false; });
    });
  });

  var rtrack = document.getElementById('zreviews');
  if(rtrack){ 
    var rscroll = function(dir){ var card = rtrack.querySelector('.rcard'); var w = card ? card.offsetWidth + 20 : 360; rtrack.scrollBy({left: dir*w, behavior:'smooth'}); };
    document.getElementById('zrev-prev').addEventListener('click', function(){ rscroll(-1); });
    document.getElementById('zrev-next').addEventListener('click', function(){ rscroll(1); });
  }

  var faq = document.getElementById('zfaq');
  if(faq){
    faq.addEventListener('click', function(e){
      var q = e.target.closest('.faq-q');
      if(!q) return;
      var item = q.closest('.faq-item');
      var fbody = item.querySelector('.faq-body');
      var isOpen = item.classList.contains('open');
      faq.querySelectorAll('.faq-item').forEach(function(it){
        it.classList.remove('open');
        it.querySelector('.faq-q').setAttribute('aria-expanded','false');
        it.querySelector('.faq-body').style.maxHeight = '0px';
      });
      if(!isOpen){ item.classList.add('open'); q.setAttribute('aria-expanded','true'); fbody.style.maxHeight = (fbody.scrollHeight + 4) + 'px'; }
    });
  }

  var gform = document.getElementById('zgive-form');
  if(gform){ 
    gform.addEventListener('submit', function(e){
      e.preventDefault();
      if(!gform.checkValidity()) return;
      gform.style.display = 'none';
      document.getElementById('zgive-success').style.display = 'inline-flex';
    });
  }

  root.querySelectorAll('.mq-track').forEach(function(t, i){ t.style.animationDuration = (i===0 ? 34 : 28) + 's'; });

  refresh(false);
})();
